module.exports = __webpack_public_path__ + "static/media/it_strategy_logo.4d313303.png";